export default __webpack_public_path__ + "static/media/exploded-view_sprite.db2979e9.png";